module.exports = __webpack_public_path__ + "img/programs-icon-4.15708662.png";